<template>
  <main class="main customer_main" role="main">
    <div class="main_con mb_pb">
      <div class="con_wrap">
        <ul class="list_item_ul" v-if="productList?.length > 0">
          <InternetProduct
            v-for="(item, index) in productList"
            :key="index"
            :item="item"
            :is-my-page="true"
            @view="goItemView"
          />
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>찜한 요금제가 없습니다.<br /></div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import InternetProduct from '@/front/customer/views/home/components/InternetProduct';

import format from 'date-fns/format';

export default {
  description: '찜한 인터넷 요금제',
  components: { InternetProduct },
  data() {
    return {
      params: {
        page: 1,
        size: 10,
        selTv: '',
        selBookmark: 'Y',
      },
      productList: [],
      internetCreateCheck: true,
    };
  },
  computed: {
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
  },
  async created() {
    await this.isInternetCreateCheck();

    this.getInternetProducts();
  },
  methods: {
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
      internetTypes.SELECT_INTERNET_PRODUCTS,
    ]),
    async getInternetProducts() {
      await this[internetTypes.SELECT_INTERNET_PRODUCTS](this.params).then(
        res => {
          this.productList = res.content;
        },
      );
    },
    goItemView(item) {
      localStorage.setItem('internetProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'InternetCommerce.ItemView',
        query: {
          isInternetCreate: this.internetCreateCheck,
        },
      });
    },
    async isInternetCreateCheck() {
      let goCreateCheck = true;
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      await this.getInternetCommerceIngList();
      await this.getInternetCommerceEndList();

      // 인터넷 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 2건)
      if (this.internetCommerceIngList.content.length >= 2) {
        goCreateCheck = false;
      } else if (this.internetCommerceIngList.content.length == 1) {
        if (this.internetCommerceEndList.content.length >= 1) {
          const createdAt = new Date(
            this.internetCommerceEndList.content[0].createdAt,
          );

          const sDays = format(
            new Date(createdAt.setDate(createdAt.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 안지났음
          if (now < sDays) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.internetCommerceIngList.content.length == 0) {
        if (this.internetCommerceEndList.content.length >= 2) {
          const createdAt_1 = new Date(
            this.internetCommerceEndList.content[0].createdAt,
          );

          const sDays_1 = format(
            new Date(createdAt_1.setDate(createdAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const createdAt_2 = new Date(
            this.internetCommerceEndList.content[1].createdAt,
          );

          const sDays_2 = format(
            new Date(createdAt_2.setDate(createdAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 둘다 안지났음
          if (now < sDays_1 && now < sDays_2) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
      this.internetCreateCheck = goCreateCheck;
    },
    async getInternetCommerceIngList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'ING',
        orderType: 'CREATED_AT_DESC',
      });
    },
    async getInternetCommerceEndList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'END',
        orderType: 'CREATED_AT_DESC',
      });
    },
  },
};
</script>
